import React from "react";
import { useBusinessActivitiesReportDownloader } from "../../../../data/reports/exchbusiness/businessActivities/hooks/useBusinessActivitiesReportDownloader";
import { useBusinessActivitiesExcelDownloader } from "../../../../data/reports/exchbusiness/businessActivities/hooks/useBusinessActivitiesExcelDownloader";
import DownloadIcon from "@material-ui/icons/CloudDownloadOutlined";
import ExcelIcon from "@material-ui/icons/TableChartOutlined";
import { IconButton } from "@material-ui/core";
import { CustomTooltip } from "../../../components/common/CustomTooltip";

export const DownloadButton: React.FunctionComponent = () => {
  const [downloader, fetchState] = useBusinessActivitiesReportDownloader();
  return (
    <CustomTooltip titleKeyword="exportPDFTooltip">
      <IconButton
        color="secondary"
        component="span"
        onClick={downloader}
        disabled={fetchState.type !== "not-started"}
      >
        <DownloadIcon />
      </IconButton>
    </CustomTooltip>
  );
};

export const DownloadExcelButton: React.FunctionComponent = () => {
  const [downloader, fetchState] = useBusinessActivitiesExcelDownloader();
  return (
    <CustomTooltip titleKeyword="exportXLSXTooltip">
      <IconButton
        color="secondary"
        component="span"
        onClick={downloader}
        disabled={fetchState.type !== "not-started"}
      >
        <ExcelIcon />
      </IconButton>
    </CustomTooltip>
  );
};
